package com.cybersoftsolution.cybersoftsolutionweb.styles

import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.selectedColor
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.unselectedColor
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val SubscribeBarCollapsableStyle = CssStyle {
    base {
        Modifier
            .background(Theme.Transparent.rgb)
            .border(
                width = 2.px,
                style = LineStyle.Solid,
//           color = Theme.Primary.rgb
                color = unselectedColor
            )
            .outline(
                width = 0.px,
                style = LineStyle.None,
                color = Colors.Transparent
            )
            .transition(Transition.of(property = "border", duration = 300.ms))
    }
    focus {
        Modifier.border(
            width = 2.px,
            style = LineStyle.Solid,
            color = selectedColor
        )
            .outline(
                width = 0.px,
                style = LineStyle.None,
                color = selectedColor
            )
    }

    hover {
        Modifier.border(
            width = 2.px,
            style = LineStyle.Solid,
            color = unselectedColor
        )
            .outline(
                width = 0.px,
                style = LineStyle.None,
                color = unselectedColor
            )
    }


}
